import type { Translation } from './translation.js'

const fi: Translation = {
  '$lang': 'fi',
  '$name': 'Suomi',
  '$dir': 'ltr',

  'nord-command-menu': {
    instructions: 'Paina \'Enter\' vahvistaaksesi valinnan tai \'Escape\' peruuttaaksesi',
    inputLabel: 'Kirjoita komento jonka haluat suorittaa.',
    footerArrowKeys: 'Siirry',
    footerEnterKey: 'Valitse',
    footerEscapeKey: 'Esc sulje',
    footerBackspaceKey: 'Siirry takaisin',
    noResults: searchTerm => `Ei tuloksia haulle "${searchTerm}"`,
    tip: 'Vinkki: jotkin haut vaativat tarkan hakutermin. Koita kirjoittaa koko hakutermi kokonaisuudessaan, tai kokeile toista sanaa tai fraasia.',
    placeholder: 'Kirjoita komento tai hakusana…',
  },

  'nord-calendar': {
    prevMonthLabel: 'Edellinen kuukausi',
    nextMonthLabel: 'Seuraava kuukausi',
    monthSelectLabel: 'Kuukausi',
    yearSelectLabel: 'Vuosi',
  },

  'nord-date-picker': {
    modalHeading: 'Valitse päivämäärä',
    closeLabel: 'Sulje ikkuna',
    buttonLabel: 'Valitse päivämäärä',
    selectedDateMessage: 'Valittu päivämäärä on',
    dateOutOfMinBound: (minDate: string) => `Päivämäärä on oltava ${minDate} tai myöhemmin`,
    dateOutOfMaxBound: (maxDate: string) => `Päivämäärä on oltava ${maxDate} tai aikaisemmin`,
  },

  'nord-modal': {
    closeLabel: 'Sulje ikkuna',
  },

  'nord-nav-toggle': {
    label: 'Näytä/Piilota valikko',
  },

  'nord-textarea': {
    remainingCharacters: (remaining: number) => `${remaining} merkkiä jäljellä`,
  },

  'nord-notification': {
    dismissLabel: 'Sulje ilmoitus',
  },

  'nord-message': {
    unreadLabel: 'Lukematon',
  },

  'nord-tag': {
    removeLabel: 'Poista',
  },
}

export default fi
